import React, { forwardRef } from 'react';
import { Row, Col, Card, Divider } from 'antd';

import { CabecalhoModal } from '../SecaoDetalhamento/CabecalhoModal';
import { HeaderDetalhamento } from '../SecaoDetalhamento/HeaderDetalhemento';
import { Motorista } from '../SecaoDetalhamento/DadosMotorista/Motorista';
import { Veiculo } from '../SecaoDetalhamento/DadosMotorista/Veiculo';
import { CardConsulta } from '../SecaoDetalhamento/DadosConsultas/CardConsulta';

import * as S from '../SecaoDetalhamento/styles';

export const TemplateToPrint = forwardRef((props, ref) => (
    <Col className="print-container" ref={ref}>
      <Row>
        <Col span={24}>
          <CabecalhoModal data={props?.data} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <HeaderDetalhamento solicitacao={props?.data} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            style={{ margin: '8px 0', borderRadius: '16px' }}
          >
            <Motorista data={props?.data?.motorista} />
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            style={{ margin: '8px 0', borderRadius: '16px' }}
          >
            {props?.data?.veiculos?.map((veiculo, index) => (
              <div className="page-break">
                {props?.data?.veiculos?.length !== index && index !== 0 && (
                  <Row
                    gutter={[2, 8]}
                    style={{ padding: '0 26px 0 0' }}
                    justify="space-between"
                  >
                    <Col className="gutter-row" span={24}>
                      <Divider
                        style={{
                          margin: 0,
                          padding: 0,
                          border: '0.5px solid #C2CCD1',
                        }}
                      />
                    </Col>
                  </Row>
                )}
                <Veiculo veiculo={veiculo} key={index?.toString()} />
              </div>
            ))}
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            style={{ margin: '8px 0', borderRadius: '16px' }}
          >
            <Col span={24} style={{ marginBottom: 26 }}>
              <Row>
                <Col flex="auto">
                  <S.TitleSectionMotorista>Atendimento</S.TitleSectionMotorista>
                </Col>
              </Row>
            </Col>
            <Col span={22} style={{ paddingBottom: 32 }}>
              <Row gutter={[48, 24]}>
                {props?.data?.consultasAtendimento?.map((item, index) => (
                  <CardConsulta data={item} key={index} />
                ))}
              </Row>
            </Col>
            <Col span={24}>
              <Row style={{ marginBottom: 12 }}>
                <S.ModalTitle>Observações</S.ModalTitle>
              </Row>
              <Row>
                <Col span={17}>
                  <S.TextAreaDetalhamento
                    disabled
                    autoSize={{ minRows: 5, maxRows: 5 }}
                    value={props?.data?.motivoFinalizacao || ''}
                  />
                </Col>
              </Row>
            </Col>
          </Card>
        </Col>
      </Row>
    </Col>
  ));
